import gql from 'graphql-tag';

export const FRAGMENT_MULTI_PROMPT_INPUT = gql`
  fragment MultiPromptInput on MultiPromptInput {
    name
    description
    instructions
  }
`;

export const FRAGMENT_MULTI_PROMPT_INPUTS = gql`
  fragment MultiPromptInputs on MultiPromptInputs {
    projectType
    inputs {
      ...MultiPromptInput
    }
  }
  ${FRAGMENT_MULTI_PROMPT_INPUT}
`;

export const FRAGMENT_MULTI_PROMPT_BLOCK = gql`
  fragment MultiPromptBlock on MultiPromptBlock {
    name
    dependentInputs
    generatedPrompt
    allInstructionsData
    structureInstructionsData
    type
    reasoning
    imageAspectRatio
  }
`;

export const FRAGMENT_MULTI_PROMPT_BLOCKS = gql`
  fragment MultiPromptBlocks on MultiPromptBlocks {
    blocks {
      ...MultiPromptBlock
    }
  }
  ${FRAGMENT_MULTI_PROMPT_BLOCK}
`;

export const FRAGMENT_CSV_FILE = gql`
  fragment CSVFile on CSVFile {
    id
    name
    headers
    sampleData
    size
  }
`;

export const FRAGMENT_MULTI_PROMPT_TEMPLATE = gql`
  fragment CustomerMultiPromptTemplate on CustomerMultiPromptTemplate {
    id
    name
    description
    info
    fields
    blocks
    status
    templateGroup
    smallImage
    wideImage
    bigImage
    iconImage
    isReleasedSrc
    primaryKey
    selectedHeaders
    templateType
    templateOutputType
    csvFile {
      ...CSVFile
    }
    projectType
    tags
    createdBy
    exampleContent
  }
  ${FRAGMENT_CSV_FILE}
`;

export const FRAGMENT_MULTI_PROMPT_TEMPLATES = gql`
  fragment CustomerMultiPromptTemplates on CustomerMultiPromptTemplates {
    templates {
      ...CustomerMultiPromptTemplate
    }
  }
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
`;

export const FRAGMENT_MULTI_PROMPT_BLOCK_CHIP = gql`
  fragment MultiPromptBlockChip on MultiPromptBlockChip {
    title
    info
  }
`;

export const FRAGMENT_MULTI_PROMPT_DATA = gql`
  fragment MultiPromptData on MultiPromptData {
    blocks {
      ...MultiPromptBlock
    }
    inputFields {
      ...MultiPromptInput
    }
    blockChips {
      ...MultiPromptBlockChip
    }
  }
  ${FRAGMENT_MULTI_PROMPT_BLOCK}
  ${FRAGMENT_MULTI_PROMPT_INPUT}
  ${FRAGMENT_MULTI_PROMPT_BLOCK_CHIP}
`;
